<template>
    <div>
        <a-modal :centered='true' :maskClosable='false' v-model.trim="affairBool"  footer='' width='980px' :closable='false'>
            <div class="affair-modal">
                <div class="affair-head">
                    <span class="affair-head-title">{{headerDetailData.moduleName}}</span>
                    <span class="affair-head-id">ID：{{dataId}}</span>
                    <div class="affair-head-btn-group">
                        <a-button @click="createAffair" class="affair-head-btn1">创建事务</a-button>
                        <a-icon class="affair-head-icon" @click="closeAffairModal" type="close" />
                    </div>
                </div>
                <div class="affair-body">
                    <div class="affair-content">
                        <div style="position: absolute;right:0px;top:300px;">
                            <div @click="toTop" class="to-bottom" style="display:inline-block;width:40px;height:40px;box-shadow: 0px 2px 16px 0px rgba(0, 0, 0, 0.12);background:#fff;border-radius: 20px;text-align: center;cursor: pointer;line-height: 40px;;">
                                <img class="to-bottom-img" style="width:24px;transform: rotate(180deg);" src="../assets/img/to-bottom.svg" alt="">
                                <div class="to-bottom-text" style="color:rgba(158, 172, 196, 1);font-size:11px;">到底部</div>
                            </div>
                            <div></div>
                            <div @click="toBottom" class="to-top" style="display:inline-block;width:40px;height:40px;box-shadow: 0px 2px 16px 0px rgba(0, 0, 0, 0.12);background:#fff;border-radius: 20px;text-align: center;cursor: pointer;line-height: 40px;margin-top:12px;">
                                <img class="to-top-img" style="width:24px;" src="../assets/img/to-bottom.svg" alt="">
                                <div class="to-top-text" style="color:rgba(158, 172, 196, 1);font-size:11px;">到顶部</div>
                            </div>
                        </div>
                        <div class="affair-scroll">
                           
                            <div class="affair-body-head">
                                <div class="affair-body-head-title">{{headerDetailData.dataTitle}}&{{headerDetailData.moduleName}}</div>
                                <a-row class="affair-body-head-row">
                                    <a-col :span="5">
                                        <span v-if="headerDetailData.createAvatar==''" class="affair-body-head-name">{{headerDetailData.createBy.length>2?headerDetailData.createBy.substr(-2,2):headerDetailData.createBy}}</span>
                                        <img style="width:36px;height:36px;border-radius:18px;float:left;object-fit: cover" v-if="headerDetailData.createAvatar!=''" :src="headerDetailData.createAvatar" alt="">
                                        <div style="display:inline-block;margin-left:12px;">
                                            <div style="color:rgba(18, 18, 18, 1);font-size:13px;">{{headerDetailData.createBy}}</div>
                                            <div style="color:rgba(158, 172, 196, 1);font-size:12px;">创建人</div>
                                        </div>
                                    </a-col>
                                    <a-col class="head-item" :span="5">
                                        <div @click="selectPerson" v-if="headerDetailData.owner==''?true:false" style="cursor:pointer;display:flex;">
                                            <a-button class="select-name" type="dashed" shape="circle" icon="user-add" />
                                            <div class="person-charge">
                                                负责人
                                            </div>
                                        </div>
                                        <div @click="selectPerson" v-if="headerDetailData.owner!=''?true:false" style="display:flex;">
                                            <span v-if="headerDetailData.ownerAvatar==''" class="selected-name">{{headerDetailData.owner.length>2?headerDetailData.owner.substr(-2,2):headerDetailData.owner}}</span>
                                            <img v-if="headerDetailData.ownerAvatar!=''" style="width:36px;height:36px;border-radius:18px;float:left;object-fit: cover" :src="headerDetailData.ownerAvatar" alt="">
                                            <div class="personal-charge">
                                                <div class="personal-charge-name">{{headerDetailData.owner}}</div>
                                                <div class="personal-charge-user">负责人</div>
                                                <a-icon @click="deleteSelectedPerson" class="personal-charge-close" type="close" />
                                            </div>
                                        </div>
                                        <UserAndProvider @getUserId='getUserId' @getProviderId='getProviderId' ref="UserAndProvider"></UserAndProvider>
                                    </a-col>
                                    <a-col :span="7" class="create-time">
                                        <div @click="selectCreateTime" style="display:flex;position:relative">
                                            <a-button class="select-time" type="dashed" shape="circle" icon="clock-circle" />
                                            <div class="time-charge">
                                                <div style="color:rgba(18, 18, 18, 1);font-size:13px;">{{headerDetailData.createTime}}</div>
                                                <div style="color:rgba(158, 172, 196, 1);font-size:12px;">创建时间</div>
                                            </div>
                                        </div>
                                    </a-col>
                                    <a-col :span="7" class="edit-time">
                                        <div @click="selectEditTime" style="display:flex;position:relative">
                                            <a-button class="select-time" type="dashed" shape="circle" icon="clock-circle" />
                                            <div class="time-charge">
                                                <div style="color:rgba(18, 18, 18, 1);font-size:13px;">{{headerDetailData.updateTime}}</div>
                                                <div style="color:rgba(158, 172, 196, 1);font-size:12px;">修改时间</div>
                                            </div>
                                        </div>
                                    </a-col>
                                </a-row>
                                <div class="affair-tab">
                                    <span @click="selectAffairTab('数据详情', undefined)" :class="{'active':currentTab=='数据详情'}">数据详情</span>
                                    <span v-for="(item, index) in tabListData" :key='index' @click="selectAffairTab(item.name, item.id)" :class="{'active':currentTab==item.name}">{{item.name}}</span>
                                    <span @click="selectAffairTab('附件', 'attachment')" :class="{'active':currentTab=='附件'}">附件</span>
                                </div>
                            </div>
                            <div v-if="currentTab=='数据详情'" class="tab-content">
                                <a-row class="tab-content-row" style="margin-top:20px;">
                                    <div v-for="(item, index) in fieldList" :key='index'>
                                        <a-col :span="12" v-if="item.type=='SHORT_TEXT'">
                                            <div>
                                                <div style="color:rgba(158, 172, 196, 1);font-size:13px">
                                                    <a-icon type="font-size" />
                                                    <span style="margin-left:4px;">{{item.name}}：</span>
                                                </div>
                                                <a-input @blur="fieldInputBlur(item.id,item.value)" v-model="item.value" class="edit-input" :disabled='changeJurisdiction==false||item.isEditable==false' placeholder="输入内容" />
                                            </div>
                                        </a-col>
                                        <a-col :span="12" v-if="item.type=='URL'">
                                            <div>
                                                <div style="color:rgba(158, 172, 196, 1);font-size:13px">
                                                    <a-icon type="font-size" />
                                                    <span style="margin-left:4px;">{{item.name}}：</span>
                                                </div>
                                                <a-input @blur="fieldInputBlur(item.id,item.value)" v-model="item.value" class="edit-input" :disabled='changeJurisdiction==false||item.isEditable==false' placeholder="输入内容" />
                                            </div>
                                        </a-col>
                                        <a-col :span="12" v-if="item.type=='COMMODITY_SPECIFICATIONS'">
                                            <div>
                                                <div style="color:rgba(158, 172, 196, 1);font-size:13px">
                                                    <a-icon type="font-size" />
                                                    <span style="margin-left:4px;">{{item.name}}：</span>
                                                </div>
                                                <div class="show-text">
                                                    <span>{{item.value.length>20?item.value.substr(0,20)+'...':item.value}}</span>
                                                    <a-button v-if='changeJurisdiction&&item.isEditable' @click="viewCommodity">
                                                    更改
                                                    </a-button>
                                                </div>
                                            </div>
                                        </a-col>
                                        <a-col :span="12" v-if="item.type=='ATTACHMENT'">
                                            <div>
                                                <div style="color:rgba(158, 172, 196, 1);font-size:13px">
                                                    <a-icon type="font-size" />
                                                    <span style="margin-left:4px;">{{item.name}}：</span>
                                                </div>
                                                <div class="show-text">
                                                    <span style="color:#1890ff;cursor:pointer" @click="downloadAttachment(item.value.split('@@')[1])">{{item.value.split("@@")[0]}}</span>
                                                    <a-upload
                                                        v-if='changeJurisdiction&&item.isEditable'
                                                        class="upload-file"
                                                        style="float:right"
                                                        :multiple="true"
                                                        :customRequest="customRequest3"
                                                        @change="handleChange(item.id)"
                                                    >
                                                        <div>
                                                            <a-button icon="upload">
                                                            更改附件
                                                            </a-button>
                                                        </div>
                                                    </a-upload>
                                                </div>
                                            </div>
                                        </a-col>
                                        <a-col :span="12" v-if="item.type=='INTERFACE'||item.type=='USER_MONEY'">
                                            <div>
                                                <div style="color:rgba(158, 172, 196, 1);font-size:13px">
                                                    <a-icon type="font-size" />
                                                    <span style="margin-left:4px;">{{item.name}}：</span>
                                                </div>
                                                <div class="show-text">{{item.value}}</div>
                                            </div>
                                        </a-col>
                                        <a-col :span="12" v-if="item.type=='USER_CERTIFICATION'">
                                            <div>
                                                <div style="color:rgba(158, 172, 196, 1);font-size:13px">
                                                    <a-icon type="font-size" />
                                                    <span style="margin-left:4px;">{{item.name}}：</span>
                                                </div>
                                                <a-input @blur="fieldInputBlur(item.id,item.value)" v-model="item.value" class="edit-input" :disabled='changeJurisdiction==false||item.isEditable==false' placeholder="输入内容" />
                                            </div>
                                        </a-col>
                                        <a-col :span="12" v-if="item.type=='IMAGE'">
                                            <div>
                                                <div style="color:rgba(158, 172, 196, 1);font-size:13px">
                                                    <a-icon type="font-size" />
                                                    <span style="margin-left:4px;">{{item.name}}：</span>
                                                </div>
                                                <div class="img-text">
                                                    <img @click="viewPic(item.value)" :src="item.value" alt="">
                                                </div>
                                            </div>
                                        </a-col>
                                        <a-col :span="12" v-if="item.type=='NUMBER'||item.type=='NUMBER_MONEY'">
                                            <div>
                                                <div style="color:rgba(158, 172, 196, 1);font-size:13px">
                                                    <a-icon type="font-size" />
                                                    <span style="margin-left:4px;">{{item.name}}：</span>
                                                </div>
                                                <a-input-number :disabled='changeJurisdiction==false||item.isEditable==false' @blur="fieldInputBlur(item.id,item.value)" v-model="item.value" class="edit-input" placeholder="输入内容" />
                                            </div>
                                        </a-col>
                                        <a-col :span="12" v-if="item.type=='TIME_YYYYMMDD'">
                                            <div style="color:rgba(158, 172, 196, 1);font-size:13px">
                                                <a-icon type="font-size" />
                                                <span style="margin-left:4px;">{{item.name}}：</span>
                                            </div>
                                            <div style="margin-top:8px;" class="end-date">
                                                <div class="date-text" style="color:rgba(18, 18, 18, 1);font-size:13px;padding-left:11px;">{{item.value}}</div>
                                                <a-date-picker :disabled='changeJurisdiction==false||item.isEditable==false' class="date-picker" @blur="fieldDatePickBlur(item.id)" @change="onChangeEndDate" format="YYYY-MM-DD"/>
                                            </div>
                                        </a-col>
                                        <a-col :span="12" v-if="item.type=='TIME_YYYYMMDDHHMMSS'">
                                            <div style="color:rgba(158, 172, 196, 1);font-size:13px">
                                                <a-icon type="font-size" />
                                                <span style="margin-left:4px;">{{item.name}}：</span>
                                            </div>
                                            <div style="margin-top:8px;" class="end-date">
                                                <div class="date-text" style="color:rgba(18, 18, 18, 1);font-size:13px;padding-left:11px;">{{item.value}}</div>
                                                <a-date-picker class="date-picker" :disabled='changeJurisdiction==false||item.isEditable==false' @blur="fieldDatePickBlur(item.id)" @change="onChangeEndDate" format="YYYY-MM-DD HH:mm:ss"/>
                                            </div>
                                        </a-col>
                                        <a-col :span="12" v-if="item.type=='LABEL'">
                                            <div style="color:rgba(158, 172, 196, 1);font-size:13px">
                                                <a-icon type="font-size" />
                                                <span style="margin-left:4px;">{{item.name}}：</span>
                                            </div>
                                            <div class="affair-tags">
                                                <div style="display:inline-block;" v-for="(item1,index1) in item.value" :key='index1'>
                                                    <span class="selected-item" :style="{'background':item1.color}">
                                                        {{item1.name}}
                                                        <a-icon v-if='changeJurisdiction&&item.isEditable' @click="removeTag(item1.id)" type="close" />
                                                    </span>
                                                </div>
                                                <span class="plus-button" v-if='changeJurisdiction&&item.isEditable'>
                                                    <span class="carry-btn" @click="addTags">
                                                        <a-icon type="plus" />
                                                        添加标签
                                                    </span>
                                                    <div class="tags-box" v-if="tagsBool" @click="selectLabelBox">
                                                        <div style="padding:0 20px;position:relative;">
                                                            <a-input @change="queryLabelList()" v-model="searchLabelName" placeholder="搜索姓名" style="padding-left:32px;border:1px solid rgba(158, 172, 196, 0.3)" />
                                                            <a-icon style="position:absolute;left:30px;top:9px;color:rgba(158, 172, 196, 0.7)" type="search" />
                                                        </div>
                                                        <ul class="tags-list">
                                                            <li @click="chooseTag(index,item.id)" class="tags-list-li" v-for="(item,index) in tagsList" :key='index'>
                                                                <span>{{item.name}}</span>
                                                                <a-icon v-if="item.selected" type="check" />
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </span>
                                            </div>
                                        </a-col>
                                        <a-col :span="12" v-if="item.type=='SELECT_SINGLE'||item.type=='SELECT_SINGLE_ROLE'">
                                            <div style="color:rgba(158, 172, 196, 1);font-size:13px">
                                                <a-icon type="font-size" />
                                                <span style="margin-left:4px;">{{item.name}}：</span>
                                            </div>
                                            <div class="related-business">
                                                <div class="related-text">{{item.value}}</div>
                                                <a-select class="related-selected" :disabled='changeJurisdiction==false||item.isEditable==false' @change="changeDataLink(item.id, item.value)" v-model="item.value" :showArrow="false">
                                                    <a-select-option :value="item1.value" v-for="(item1, index1) in item.selectList" :key='index1'>
                                                        {{item1.name}}
                                                    </a-select-option>
                                                </a-select>
                                            </div>
                                        </a-col>
                                        <a-col :span="12" v-if="item.type=='COMMODITY_USER'">
                                            <div style="color:rgba(158, 172, 196, 1);font-size:13px">
                                                <a-icon type="link" />
                                                <span style="margin-left:4px;">客户账号数量</span>
                                            </div>
                                            <div style="margin-top:8px;" class="end-date">
                                                <span style="color:rgba(18, 18, 18, 1);font-size:13px;padding-left:11px;margin-right:16px;">{{item.value}}</span>
                                                <a-button @click="connectAccount(item.id)" style="height:28px;margin-top:7px;line-height:26px;font-size:13px;" type="primary" ghost>
                                                关联账号
                                            </a-button>
                                            </div>
                                        </a-col>
                                        <a-col :span="24" v-if="item.type=='LONG_TEXT'" class="col-textarea">
                                            <div style="color:rgba(158, 172, 196, 1);font-size:13px">
                                                <a-icon type="font-size" />
                                                <span style="margin-left:4px;">{{item.name}}：</span>
                                            </div>
                                            <a-textarea :disabled='changeJurisdiction==false||item.isEditable==false' @blur="fieldInputBlur(item.id,item.value)" v-model="item.value" class="textarea-content" placeholder="请输入内容" :rows="4" />
                                        </a-col>
                                        <a-col :span="24" v-if="item.type=='COLLABORATOR'">
                                            <div style="color:rgba(158, 172, 196, 1);font-size:13px">
                                                <a-icon type="font-size" />
                                                <span style="margin-left:4px;">协助人：</span>
                                            </div>
                                            <div class="helper" style="color:#fff;font-size:12px;margin-top:12px;">
                                                <div v-for="(item1,index1) in item.value" :key='index1' style="display:inline-block;float:left">
                                                    <div class="personal">
                                                        <span v-if="item1.avatar==''" class="personal-title" :title="item1.name">{{item1.name.substr(-2,2)}}</span>
                                                        <img :title="item1.name" v-if="item1.avatar!=''" class="personal-img" style="object-fit: cover" :src="item1.avatar" alt="">
                                                        <span class="personal-edit" v-if='changeJurisdiction&&item.isEditable' @click="deleteHelper(item1.id)">
                                                            <a-icon type="close" />
                                                        </span>
                                                    </div>
                                                </div>
                                                <div v-if='changeJurisdiction&&item.isEditable' @click="chooseHelper" class="personal-add">
                                                    <a-icon type="plus" />
                                                </div>
                                                <Helper @queryDetailsData='queryDetailsData' :helperValueList='helperValueList' :dataId='dataId' :moduleId='moduleId' :personBoxBool='personBoxBool' ref="Helper"></Helper>
                                            </div>
                                        </a-col>
                                        <a-col :span="24" v-if="item.type=='SUPERIOR'">
                                            <div style="color:rgba(158, 172, 196, 1);font-size:13px">
                                                <a-icon type="font-size" />
                                                <span style="margin-left:4px;">上级：</span>
                                            </div>
                                            <div class="helper" style="color:#fff;font-size:12px;margin-top:12px;">
                                                <div v-for="(item1,index1) in item.value" :key='index1' style="display:inline-block;float:left">
                                                    <div class="personal">
                                                        <span v-if="item1.avatar==''" class="personal-title" :title="item1.name">{{item1.name.substr(-2,2)}}</span>
                                                        <img :title="item1.name" v-if="item1.avatar!=''" class="personal-img" style="object-fit: cover" :src="item1.avatar" alt="">
                                                        <span class="personal-edit" v-if='changeJurisdiction&&item.isEditable' @click="deleteSuperior(item1.id)">
                                                            <a-icon type="close" />
                                                        </span>
                                                    </div>
                                                </div>
                                                <div v-if='changeJurisdiction&&item.isEditable' @click="chooseSuperior" class="personal-add">
                                                    <a-icon type="plus" />
                                                </div>
                                                <Superior @queryDetailsData='queryDetailsData' :superiorValueList='superiorValueList' :dataId='dataId' :moduleId='moduleId' :superiorBoxBool='superiorBoxBool' ref="Superior"></Superior>
                                            </div>
                                        </a-col>
                                        <a-col :span="24" v-if="item.type=='ASSOCIATED_SINGLE'||item.type=='ASSOCIATED_BUSINESS'">
                                            <div style="color:rgba(158, 172, 196, 1);font-size:13px">
                                                <a-icon type="paper-clip" />
                                                <span style="margin-left:4px;">{{item.name}}：</span>
                                            </div>
                                            <span style="margin-right:20px;color:#1890ff;cursor:pointer;display:inline-block;" v-html="item.value"></span>
                                            <a-button v-if='changeJurisdiction&&item.isEditable' @click="connectModular(item.id)" style="height:28px;margin-top:7px;line-height:26px;font-size:13px;" type="primary" ghost>
                                                关联模块
                                            </a-button>
                                        </a-col>
                                    </div>
                                </a-row>
                            </div>
                            <div v-for="(item, index) in tabListData" :key='index'>
                                <div v-if="currentTab==item.name" style="min-height: 240px;">
                                    <div v-if="item.name!='协同事务'&&hasAddAuthority" style="height:40px;padding-top:12px">
                                        <div @click="addTabDetail(item.id)" style="float:right;height:28px;display: inline-block;display: inline-block;width:96px;height:28px;background:rgba(158, 172, 196, 0.12);font-size:13px;text-align: center;line-height: 28px;cursor: pointer;color:rgba(158, 172, 196, 1)">
                                            <img style="width:18px;" src="../../src/assets/img/add.svg" alt="">
                                            <span>添加数据</span>
                                        </div>
                                    </div>
                                    <div v-for="(item,index) in currentTabDetailData" :key='index' class="tab-detail">
                                        <span class="tab-title" v-html="item.dataTitle"></span>
                                        <span class="tab-label" v-html="item.label"></span>
                                        <span v-if="item.avatar==''" class="tab-owner" :title="item.owner">{{item.owner.substr(-2,2)}}</span>
                                        <img v-if="item.avatar!=''" style="object-fit: cover" class="tab-img" :title="item.owner" :src="item.avatar" alt="">
                                        <span class="tab-createtime">{{item.createTime}}</span>
                                    </div>
                                    <div v-if="currentTabDetailData.length==0">
                                        <div style="text-align:center;padding-top: 80px;">
                                            <img style="width:56px;" src="../../src/assets/img/no-data.png" alt="">
                                        </div>
                                        <div style="color:rgba(158, 172, 196, 0.7);font-size:12px;text-align:center;">暂无数据</div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="currentTab=='附件'" class="tab-attachment">
                                <div class="attachment-head">
                                    <span class="total-data">共{{attachmentList.length}}条数据</span>
                                    <a-upload
                                        class="upload-file"
                                        :multiple="true"
                                        :customRequest="customRequest2"
                                    >
                                        <div>
                                            <a-button icon="upload">
                                            添加附件
                                            </a-button>
                                        </div>
                                    </a-upload>
                                </div>
                                <ul class="attachment-list">
                                    <li v-for="(item,index) in attachmentList" :key='index'>
                                        <div class="attachment-top">
                                            <img style="width:28px;margin-right:12px;float: left;" src="../../src/assets/img/file.png" alt="">
                                            <span class="attachment-name">{{item.originName}}</span>
                                            <div class="attachment-btn-group" style="margin-top:8px;">
                                                <a-icon @click="downloadAttachment(item.downloadUrl)" type="download" />
                                                <a-icon @click="showDeleteAttachmentModal(item.id)" type="delete" />
                                            </div>
                                            <div class="attachment-bottom" style="display:inline-block;float: right;margin-top:8px;">
                                                <span>{{item.size}}</span>
                                                <span>{{item.createBy}}</span>
                                                <span>{{item.createTime}}</span>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            <div class="comment">
                                <span class="comment-title">讨论</span>
                            </div>
                            <div class="comment-content">
                                <div class="comment-list" v-for="(item,index) in commentTree" :key='index'>
                                    
                                    <div class="responce-content">
                                        <div style="display: flex;min-height:68px;padding:16px 16px 0;background:rgba(158, 172, 196, 0.3);border-radius: 8px 8px 0 0;margin-bottom:16px;">
                                            <div style="flex:1">
                                                <div class="response-text" v-html="item.content"></div>
                                                <div class="name">
                                                    <span>{{item.createTime}}</span>
                                                </div>
                                            </div>
                                            <div style="display: inline-block;width:40px;">
                                                <img v-if="item.avatar!=''&&item.avatar!=null" :src="item.avatar" alt="" style="object-fit: cover">
                                                <span class="username" v-if="item.commentBy!=null&&item.commentBy!=''&&(item.avatar==''||item.avatar==null)">
                                                    {{(item.commentBy).substr(0, 1)}}
                                                </span>
                                                <span style="font-size:12px" v-if="item.commentBy==null||item.commentBy==''">
                                                    已删用户
                                                </span>
                                            </div>
                                        </div>
                                        <div style="padding:0 16px">
                                            <div style="width:100%;clear:both;margin-bottom:8px;" v-for="(item1,index1) in item.children" :key='index1'>
                                                <div v-if="item1.isMyself==0" style="display:flex;max-width:680px;">
                                                    <img v-if="item1.avatar!=''&&item1.avatar!=null" style="width:40px;height:40px;border-radius: 20px;margin-right:0px;object-fit: cover;" :src="item1.avatar" alt="">
                                                    <span style="display: inline-block;width: 40px;height: 40px;border-radius: 20px;color: #fff;text-align: center;line-height: 40px;background: rgba(121, 72, 234, 0.6);font-size: 20px;margin-right: 0px;" v-if="item1.commentBy!=null&&item1.commentBy!=''&&(item1.avatar==''||item1.avatar==null)">
                                                        {{(item1.commentBy).substr(0, 1)}}
                                                    </span>
                                                    <span style="display: inline-block;width: 40px;height: 40px;border-radius: 20px;color: #fff;text-align: center;line-height: 40px;background: rgba(121, 72, 234, 0.6);font-size: 20px;margin-right: 0px;" v-if="item1.commentBy==null||item1.commentBy==''">
                                                        已删
                                                    </span>

                                                    <div style="flex:1;margin-left:8px;">
                                                        <div style="padding:8px;background:#fff;border-radius:8px;word-break: break-all" v-html="item1.content"></div>
                                                        <div style="color:rgba(158, 172, 196, 0.7);font-size:12px;margin-top:4px;">{{item1.createTime}}</div>
                                                    </div>
                                                </div>
                                                <div v-if="item1.isMyself==1" style="display:flex;max-width:680px;float: right;">
                                                    <!-- <span class="name1">{{item1.commentBy}}</span> -->
                                                    <!-- <span class="res">回复</span> -->
                                                    <!-- <span class="name2">{{item1.replyTo}}：</span> -->
                                                    <!-- <span class="res-text" v-html="item1.content"></span>
                                                    <span class="time">{{item1.createTime}}</span> -->
                                                    <!-- <img style="width:40px;height:40px;border-radius: 20px;margin-right:0px;;" :src="item1.avatar" alt=""> -->
                                                    <div style="flex:1;margin-left:8px;">
                                                        <div style="padding:8px;background:#fff;border-radius:8px;word-break: break-all" v-html="item1.content"></div>
                                                        <div style="color:rgba(158, 172, 196, 0.7);font-size:12px;margin-top:4px;text-align:right">{{item1.createTime}}</div>
                                                    </div>
                                                </div>
                                                <div style="clear:both"></div>
                                            </div>
                                            <div style="position:relative">
                                                <div class="textarea-comment1 content-comment" id='comment-textarea2' style="background:#fff" contenteditable=true ref="menuItem2">
                                        
                                                </div>
                                                <div class="release">
                                                    <span @click="showSonUserBox(index)" class="symbol-icon">@</span>
                                                    <div class="selected-user">
                                                        <div v-for="(item2, index2) in selectedUserList" :key='index2'>
                                                            <span>{{item2.name}}</span>
                                                            <a-icon @click="removeSonUserList(index2)" type="close" />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div style="margin-top:6px;">
                                                    <div @click="submitComment(0,index,item.id)" style="color:#1890ff;cursor:pointer;display:inline-block">发送</div>
                                                </div>
                                                <div contenteditable=false v-if="boolList[index]" class="user-list2">
                                                    <ul>
                                                        <li @click="chooseUser2(item1)" v-for="(item1,index1) in userList" :value="item1.id" :key='index1'>{{item1.name}}</li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                        
                                    </div>
                                    
                                </div>
                            </div>
                        </div>
                        <div class="comment-box" style="height:120px;">
                            <span v-if="loginUserAvatar==''" class="comment-box-name">{{loginUserName.length>2?loginUserName.substr(-2,2):loginUserName}}</span>
                            <img style="width:36px;height:36px;border-radius:18px;float:left;margin-right:12px;object-fit: cover" v-if="loginUserAvatar!=''" :src="loginUserAvatar" alt="">
                            <!-- <a-textarea class="comment-textarea" @blur="textareaBlur" @focus="textareaFocus" :style="{height:textareaHeight+'px'}" v-model="commentContent" placeholder="评论内容，文字上限2000" />
                            <div class="comment-btn-group" v-if="textareaHeight==100">
                                <span @click="calcelSend">取消</span>
                                <span @click="sureSend">发送</span>
                            </div> -->
                            <div style="flex:1">
                                <div class="textarea-comment2 content-comment" id='comment-textarea1' contenteditable=true ref="menuItem">
                
                                </div>
                                <div class="release">
                                    <span @click="showUserListBox()" class="symbol-icon">@</span>
                                    <div class="selected-user">
                                        <div v-for="(item, index) in selectedUserList1" :key='index'>
                                            <span>{{item.name}}</span>
                                            <a-icon @click="removeUserList(index)" type="close" />
                                        </div>
                                    </div>
                                    <div class="cancel-submit">
                                        <span @click="calcelSend()">取消</span>
                                        <span @click="submitComment(1)">发布话题</span>
                                    </div>
                                    <div contenteditable=false v-if="userBool" class="user-list1">
                                        <ul>
                                            <li @click="chooseUser1(item1)" v-for="(item1,index1) in userList" :value="item1.value" :key='index1'>{{item1.name}}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <OperationBtn ref="operationBtn" :dataId="dataId" :moduleId="moduleId" @closeAffairModel='closeAffairModel' @queryParentBasicData='queryParentBasicData' @queryDetailsData='queryDetailsData'></OperationBtn>
                </div>
            </div>
        </a-modal>
        <a-modal :centered='true' :maskClosable='false' v-model.trim="createNewAffairModal" :closable='false' footer='' width='480px' :style="{ zIndex: 1000000000000 }">
            <div class="add-new-data-modal">
                <div class="add-title">
                    <span>确认创建</span>
                    <a-icon @click="cancelCreateNewAffair" type="close" />
                </div>
                <div class="add-data">
                    <a-input v-model="transactionName" placeholder="请输入事务名称" />
                </div>
                <div class="btn-group">
                    <div>
                        <a-button type="default" @click="cancelCreateNewAffair">取消</a-button>
                        <a-button type="primary" @click="sureCreateNewAffair">确认</a-button>
                    </div>
                </div>
            </div>
        </a-modal>
        <a-modal :centered='true' :maskClosable='false' v-model.trim="deleteAttachmentModal" :closable='false' footer='' width='480px'>
            <div class="add-new-data-modal">
                <div class="add-title">
                    <span>确认删除</span>
                    <a-icon @click="cancelDeleteAttachment" type="close" />
                </div>
                <div class="add-data">
                    <a-icon type="question-circle" />
                    <span>您确定要删除这个附件？</span>
                </div>
                <div class="btn-group">
                    <div>
                        <a-button type="default" @click="cancelDeleteAttachment">取消</a-button>
                        <a-button type="primary" @click="sureDeleteAttachment">确认</a-button>
                    </div>
                </div>
            </div>
        </a-modal>
        <a-modal :centered='true' :maskClosable='false' v-model.trim="picModal" :closable='false' footer='' width='480px'>
            <div class="add-new-data-modal">
                <div class="add-title">
                    <a-icon @click="cancelShowPic" type="close" />
                </div>
                <div class="pic-content">
                    <img :src="picUrl" alt="">
                </div>
            </div>
        </a-modal>
        <a-modal :centered='true' :maskClosable='false' v-model.trim="comodityModal" :closable='false' footer='' width='980px'>
            <div class="comodity-modal">
                <div class="add-title">
                    <span>商品规格</span>
                    <a-icon @click="cancelComodity" type="close" />
                </div>
                <div class="comodity-data">
                    <div class="good-item" style="margin-top:0px;" v-for="(item,index) in dimensionList" :key='index'>
                        <div class="item-name" style="margin-top:20px;">{{item.dimensionName}}</div>
                        <div class="item-content item-choose1">
                            <div style="margin-top:20px;" @click="chooseSpecifications1(index,item2.specificationsId)" :class="{'active':selectArr[index]['selected']==item2.specificationsId}" class="item-select item-select2" v-for="(item2,index2) in item.specificationsList" :key='index2'>
                                <span>{{item2.description}}</span>
                                <span v-if="item2.discount!=100">{{item2.discount%10!=0?item2.discount:item2.discount/10}}折</span>
                            </div>
                        </div>
                    </div>
                    <div class="good-item">
                        <div class="item-name"></div>
                        <div class="item-content">
                            <div v-if="discountInfo.discountPrice!=undefined" style="color:rgba(58, 220, 255, 1);font-size:20px;font-weight:bold">￥{{discountInfo.discountPrice}}</div>
                            <div v-if="discountInfo.discountPrice!=undefined">
                                <span style="color:rgba(153, 153, 153, 1);font-size:12px;text-decoration:line-through">￥{{discountInfo.originalPrice}}元</span>
                                <span style="width:36px;height:16px;color:rgba(255, 87, 51, 1);font-size:12px;display:inline-block;text-align:center;line-height:16px;background:rgba(255, 87, 51, 0.3);margin:0 8px;border-radius:8px;">{{discountInfo.discount%10!=0?discountInfo.discount:discountInfo.discount/10}}折</span>
                                <span style="color:rgba(153, 153, 153, 1);font-size:12px;">立省{{discountInfo.originalPrice-discountInfo.discountPrice}}元</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="btn-group">
                    <div>
                        <a-button type="default" @click="cancelComodity">取消</a-button>
                        <a-button type="primary" @click="sureComodity">确认</a-button>
                    </div>
                </div>
            </div>
        </a-modal>
        <a-modal :centered='true' :maskClosable='false' v-model.trim="addNewDataModal" :closable='false' footer='' width='480px'>
            <div class="add-new-data-modal">
                <div class="add-title">
                    <span>确认新增</span>
                    <a-icon @click="cancelAddNewData" type="close" />
                </div>
                <div class="add-data">
                    <a-input v-model="inputName" placeholder="请输入名称" />
                </div>
                <div class="btn-group">
                    <div>
                        <a-button type="default" @click="cancelAddNewData">取消</a-button>
                        <a-button type="primary" @click="sureAddNewData">确认</a-button>
                    </div>
                </div>
            </div>
        </a-modal>
        <RelatedData ref="relatedData" ></RelatedData>
        <a-modal :centered='true' :maskClosable='false' v-model.trim="chooseAccountModal" :closable='false' footer='' width='1020px'>
            <div class="choose-account-modal">
                <div class="add-title">
                    <span>选择账号</span>
                    <a-icon @click="cancelChooseAccount" type="close" />
                </div>
                <div class="choose-account-data">
                    <a-row>
                        <a-col :span="13">
                            <div class="account-left-content">
                                <a-input v-model="searchNum" @input='inputChange()' placeholder="搜索号码" />
                                <div class="account-table">
                                    <a-table
                                        :row-selection="{ selectedRowKeys: selectedRowKeys1, onChange: onSelectChange1 }"
                                        :columns="columns1"
                                        :data-source="numberData1"
                                        :pagination='false'
                                        :scroll="{  y: 240 }"
                                        :rowKey="(record,index)=>{return record.id}"
                                    >
                                    </a-table>
                                </div>
                            </div>
                        </a-col>
                        <a-col :span="11">
                            <div class="account-right-content">
                                <div class="choosed-title">
                                    <span>已选择：</span>
                                    <span @click="cleanSelected">清空</span>
                                </div>
                                <div class="choosed-content">
                                    <div class="choosed-item" v-for="(item,index) in selectedRowKeys1" :key='index'>
                                        <a-icon class="choosed-phone" type="phone" />
                                        <span class="choosed-number">{{dataObj[item]}}</span>
                                        <a-icon class="choosed-close" @click="deleteSelectedNum(index)" type="close" />
                                    </div>
                                </div>
                            </div>
                        </a-col>
                    </a-row>
                    <div class="account-total">
                        <span>合计：</span>
                        <span>{{numberData1.length}}人</span>
                    </div>
                </div>
                <div class="btn-group">
                    <div>
                        <a-button type="default" @click="cancelChooseAccount">取消</a-button>
                        <a-button type="primary" @click="sureChooseAccount">确认</a-button>
                    </div>
                </div>
            </div>
        </a-modal>
        <a-modal :centered='true' :maskClosable='true' v-model.trim="imgModal" :closable='false' footer='' :width="'auto'" >
            <div style="text-align: center;position:relative">
                <a-icon @click="closeImgModal" style="position:absolute;right:12px;top:12px;color:000;font-size:16px;cursor: pointer;" type="close-circle" />
                <img :src="imgUrl" alt="">
            </div>
        </a-modal>
    </div>
</template>
<script>
    import OperationBtn from './OperationBtn'
    import UserAndProvider from './UserAndProvider'
    import Helper from './Helper'
    import RelatedData from './RelatedData'
    import Superior from './Superior.vue'
    export default {
        components: { OperationBtn, UserAndProvider, Helper, RelatedData, Superior },
        data(){
            return{
                createNewAffairModal: false,
                tabListData: [],
                commentTree: [],
                helperObjBool: {},
                textareaHeight: 40,
                loginUserName: '',
                commentContent: '',
                ifComment: true,
                deleteAttachmentModal: false,
                headerDetailData: {
                    createBy: '',
                    owner: ''
                },
                dataId: '',
                fieldList: [],
                personBoxBool: false,
                tagsBool: false,
                searchLabelName: '',
                tagsList: [],
                affairBool: false,
                moduleId: '',
                superiorBoxBool: false,
                superiorValueList: [],
                picModal: false,
                picUrl: '',
                currentTabDetailData: '',
                currentTab: '数据详情',
                attachmentList: [],
                newFormData3: '',
                comodityModal: false,
                dimensionList: [],
                commodityId: '',
                selectArr: [],
                discountInfo: '',
                changeJurisdiction: false,
                associatedModuleId: '',
                hasAddAuthority: false,
                transactionName: '',
                inputName: '',
                addNewDataModal: false,
                id: '',
                loginUserAvatar: '',
                chooseAccountModal: false,
                selectedRowKeys1: [],
                columns1: [
                    {
                        dataIndex: 'id',
                        key: 'id',
                        title: 'id',
                        colSpan: 0,
                        customRender: () => {
                            return {
                                attrs: {
                                    colSpan: 0,
                                },
                            };
                        },
                    },
                    {
                        dataIndex: 'phone',
                        scopedSlots: {
                            customRender: 'phone'
                        },
                        key: 'phone',
                        title: '账号'
                    },
                    {
                        dataIndex: 'id',
                        scopedSlots: {
                            customRender: 'id'
                        },
                        key: 'id258',
                        title: '账号ID'
                    },
                    {
                        dataIndex: 'name',
                        scopedSlots: {
                            customRender: 'name'
                        },
                        key: 'name',
                        title: '姓名'
                    },
                ],
                numberData1: [],
                timer: null,
                searchId: '',
                dataObj: {},
                searchNum: '',
                userList: [],
                userSonBool: false,
                selectedUserList: [],
                userBool: false,
                selectedUserList1: [],
                boolList: [],
                imgUrl: '',
                imgModal: false,
            }
        },
        methods: {
            closeAffairModel() {
                this.affairBool = false
            },
            createAffair() {
                this.createNewAffairModal = true
            },
            cancelCreateNewAffair() {
                this.createNewAffairModal = false
            },
            sureCreateNewAffair() {
                this.createNewAffairModal = false
                this.axios.post('/api/task', {
                    moduleId: this.moduleId,
                    dataId: this.dataId,
                    name: this.transactionName
                })
                .then(response=> {
                    if(response.data.code == 0){
                        this.$message.success('创建成功')
                        this.$emit('queryBasicData')
                        this.affairBool = false
                        this.transactionName = ''
                        this.$parent.childCarryViewDetails(response.data.data.moduleId, response.data.data.dataId)
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error);
                });
            },
            closeAffairModal() {
                this.affairBool = false
                this.$emit('queryBasicData')
                this.$refs.operationBtn.initData()
            },
            selectPerson() {
                event.stopPropagation();
                if(this.changeJurisdiction){
                    this.$refs.UserAndProvider.personBoxBool = !this.$refs.UserAndProvider.personBoxBool
                }
            },
            getUserId() {
                this.changeChargePerson(this.$refs.UserAndProvider.selectedUser)
            },
            getProviderId() {
                this.changeChargePerson(this.$refs.UserAndProvider.defaultSelectedKeys[0])
            },
            selectCreateTime() {

            },
            selectEditTime() {

            },
            selectAffairTab(data, id) {
                this.currentTab = data
                if(id != undefined && id!='attachment'){
                    this.associatedModuleId = id
                    this.getAuthority()
                    this.queryTabDetailData(id)
                }else if(id =='attachment'){
                    this.queryAttachmentData()
                }
            },
            queryTabList() {
                this.axios(
                    {
                        method:'get',
                        url:'/api/module/associatedModuleList', 
                        params: {
                            currentModuleId: this.moduleId,
                        }
                    }
                )
                .then(response=> {
                    if(response.data.code == 0){
                        this.tabListData = response.data.data
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            queryDetailsData() {
                this.axios(
                    {
                        method:'get',
                        url:'/api/module/data/detail', 
                        params: {
                            moduleId: this.moduleId,
                            dataId: this.dataId
                        }
                    }
                )
                .then(response=> {
                    if(response.data.code == 0){
                        this.changeJurisdiction = false
                        let arr = response.data.data.functionList
                        this.$refs.operationBtn.judgeOperationBtn(arr)
                        this.loginUserAvatar = response.data.data.loginUserAvatar
                        this.headerDetailData = response.data.data.header
                        this.commentTree = response.data.data.commentTree
                        this.loginUserName = response.data.data.loginUserName
                        this.boolList = []
                        for(let i = 0; i < this.commentTree.length; i++){
                            this.boolList.push(false)
                        }
                        this.fieldList = response.data.data.fieldList
                        for(let i = 0; i < this.fieldList.length; i++){
                            if(this.fieldList[i]['type'] == 'COLLABORATOR'){
                                this.helperValueList = this.fieldList[i]['value']
                            }
                            if(this.fieldList[i]['type'] == 'SUPERIOR'){
                                this.superiorValueList = this.fieldList[i]['value']
                            }
                        }
                        for(let i = 0; i < arr.length; i++){
                            if(arr[i] == '改'){
                                this.changeJurisdiction = true
                            }
                        }
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            deleteSelectedPerson() {
                event.stopPropagation();
                this.changeChargePerson('')
            },
            changeChargePerson(value) {
                this.axios.post('/api/module/data/updateOwner', {
                    moduleId: this.moduleId,
                    dataId: this.dataId,
                    value: value
                })
                .then(response=> {
                    if(response.data.code == 0){
                        this.queryDetailsData()
                        this.$emit('queryBasicData')
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error);
                });
            },
            addTags() {
                event.stopPropagation();
                this.tagsBool = true
                this.queryLabelList()
            },
            removeTag(id) {
                this.axios.delete('/api/label/deleteDataLabel',{
                    params: {
                        moduleId: this.moduleId,
                        dataId: this.dataId,
                        labelId: id
                    }
                })
                .then(response=> {
                    if(response.data.code == 0){
                        this.queryDetailsData()
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error);
                });
            },
            chooseTag(index, id) {
                event.stopPropagation();
                this.axios.post('/api/label/addDataLabel', {
                    moduleId: this.moduleId,
                    dataId: this.dataId,
                    labelId: id
                })
                .then(response=> {
                    if(response.data.code == 0){
                        this.tagsList[index]['selected'] = true
                        this.queryDetailsData()
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error);
                });
                this.$forceUpdate();
            },
            chooseHelper() {
                event.stopPropagation();
                this.personBoxBool = true
            },
            calcelHelperBox() {
                event.stopPropagation();
            },
            chooseSuperior() {
                event.stopPropagation();
                this.superiorBoxBool = true
            },
            calcelSuperiorBox() {
                event.stopPropagation();
            },
            deleteHelper(id) {
                this.axios.delete('/api/serviceProviderUser/deleteCollaborator',{
                    params: {
                        moduleId: this.moduleId,
                        dataId: this.dataId,
                        collaboratorId: id
                    }
                })
                .then(response=> {
                    if(response.data.code == 0){
                        this.queryDetailsData()
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error);
                });
            },
            deleteSuperior(id) {
                this.axios.delete('/api/serviceProviderUser/deleteSuperior',{
                    params: {
                        dataId: this.dataId,
                        superUserId: id
                    }
                })
                .then(response=> {
                    if(response.data.code == 0){
                        this.queryDetailsData()
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error);
                });
            },
            onChangeEndDate(date, dateString) {
                console.log(date, dateString);
                this.fieldInputBlur(this.currentFieldId, dateString)
            },
            submitComment(isRoot,index,id) {
                let getMenuText = ''
                let arr = []
                if(isRoot != 1){
                    getMenuText = this.$refs.menuItem2[index].innerHTML;
                    this.replyCommentId = id
                    for(let i = 0; i < this.selectedUserList.length; i++){
                        arr.push(this.selectedUserList[i]['id'])
                    }
                }else{
                    const menuItem = this.$refs.menuItem;
                    getMenuText = menuItem.innerHTML
                    for(let i = 0; i < this.selectedUserList1.length; i++){
                        arr.push(this.selectedUserList1[i]['id'])
                    }
                }
                if(isRoot == 0){
                    // document.getElementById("comment-textarea2").innerHTML = ''
                    const elements = document.querySelectorAll('.textarea-comment1');
                    // 遍历并清空每个元素的文本内容
                    elements.forEach(element => {
                        element.textContent = ''; // 清空文本内容
                    });
                }
                document.getElementById("comment-textarea1").innerHTML = ''
                let newGetMenuText = ''
                // console.log(isRoot)
                if(isRoot == 1){
                    newGetMenuText = getMenuText.replace(/img/g, "img style='display:none'");
                }else{
                    newGetMenuText = getMenuText
                }
                // console.log(newGetMenuText)
                this.axios.post('/api/comment', {
                    moduleId: this.moduleId,
                    dataId: this.dataId,
                    content: newGetMenuText,
                    isRoot: isRoot,
                    replyCommentId: isRoot==1?undefined:this.replyCommentId,
                    designeeList: arr
                })
                .then(response=> {
                    if(response.data.code == 0){
                        this.queryDetailsData()
                        this.selectedUserList1 = []
                        this.selectedUserList = []
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error);
                });
            },
            changeDataLink(id, value) {
                this.fieldInputBlur(id, value)
            },
            fieldInputBlur(id, value) {
                this.axios.post('/api/module/data/update', {
                    moduleId: this.moduleId,
                    dataId: this.dataId,
                    fieldId: id,
                    value: value
                })
                .then(response=> {
                    if(response.data.code == 0){
                        this.queryDetailsData()
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error);
                });
            },
            fieldDatePickBlur(id) {
                this.currentFieldId = id
            },
            showDeleteAttachmentModal(id) {
                this.attachmentId = id
                this.deleteAttachmentModal = true
            },
            cancelDeleteAttachment() {
                this.deleteAttachmentModal = false
            },
            sureDeleteAttachment() {
                this.deleteAttachmentModal = false
                this.axios.delete('/api/attachment/'+this.attachmentId,{
                    params: {
                        id: this.attachmentId,
                    }
                })
                .then(response=> {
                    if(response.data.code == 0){
                        this.queryAttachmentData()
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error);
                });
            },
            customRequest2(data) {
                this.newFormData2 = ''
                const formData = new FormData() 
                formData.append('file', data.file)
                this.newFormData2 = formData
                this.axios({
                    method: 'post',
                    url: '/api/file/upload',
                    headers:{
                        'Content-Type':'application/x-www-form-urlencoded'
                    },
                    data: this.newFormData2,
                
                }).then((response) => {
                    if(response.data.code == 0){
                        this.newFormData2 = ''
                        this.uploadFile(response.data.data.fileId)
                    }else{
                        this.$message.error(response.data.userTip)
                    }
                }).catch(function (error) {
                    console.log(error)
                })
            },
            uploadFile(id) {
                this.axios.post('/api/attachment', {
                    moduleId: this.moduleId,
                    dataId: this.dataId,
                    attachment: id,
                })
                .then(response=> {
                    if(response.data.code == 0){
                        this.$message.success('上传成功')
                        this.queryAttachmentData()
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error);
                });
            },
            downloadAttachment(url) {
                window.open(url)
            },
            selectLabelBox() {
                event.stopPropagation();
            },
            queryTabDetailData() {
                this.axios(
                    {
                        method:'get',
                        url:'/api/module/tabDataList', 
                        params: {
                            currentModuleId: this.moduleId,
                            dataId: this.dataId,
                            associatedModuleId: this.associatedModuleId
                        }
                    }
                )
                .then(response=> {
                    if(response.data.code == 0){
                        this.currentTabDetailData = response.data.data
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            queryAttachmentData() {
                this.axios(
                    {
                        method:'get',
                        url:'/api/attachment/list', 
                        params: {
                            moduleId: this.moduleId,
                            dataId: this.dataId,
                        }
                    }
                )
                .then(response=> {
                    if(response.data.code == 0){
                        this.attachmentList = response.data.data
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            connectModular(id) {
                this.$refs.relatedData.changeRelatedDataBoolValue()
                this.currentFieldId = id
                this.$refs.relatedData.queryMenuList()
            },
            doCommit(id, index) {
                this.replyCommentId = id
                for(let i = 0; i < this.boolList.length; i++){
                    if(i == index){
                        this.boolList[index] = true
                    }else{
                        this.boolList[i] = false
                    }
                }
                this.$forceUpdate()
            },
            offCommit() {
                for(let i = 0; i < this.boolList.length; i++){
                    this.boolList[i] = false
                }
                this.$forceUpdate()
            },
            queryLabelList() {
                this.axios(
                    {
                        method:'get',
                        url:'/api/label/list', 
                        params: {
                            moduleId: this.moduleId,
                            name: this.searchLabelName
                        }
                    }
                )
                .then(response=> {
                    if(response.data.code == 0){
                        this.tagsList = response.data.data
                        for(let i = 0 ; i < this.tagsList.length; i++){
                            this.tagsList[i]['selected'] = false
                        }
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            queryParentBasicData() {
                this.$emit('queryBasicData')
            },
            getDataIdValue(id) {
                this.dataId = id
            },
            changePersonBoxBoolValue() {
                this.personBoxBool = false
                this.superiorBoxBool = false
                this.$refs.UserAndProvider.personBoxBool = false
            },
            changeTagsBoolValue() {
                this.tagsBool = false
            },
            changeAffairBoolValue() {
                this.affairBool = true
            },
            getPassModuleId(id) {
                this.moduleId = id
            },
            viewPic(url) {
                this.picModal = true
                this.picUrl = url
            },
            cancelShowPic() {
                this.picModal = false
            },
            customRequest3(data) {
                this.newFormData3 = ''
                const formData = new FormData() 
                formData.append('file', data.file)
                this.newFormData3 = formData
                this.axios({
                    method: 'post',
                    url: '/api/file/upload',
                    headers:{
                        'Content-Type':'application/x-www-form-urlencoded'
                    },
                    data: this.newFormData3,
                
                }).then((response) => {
                    if(response.data.code == 0){
                        this.newFormData3 = ''
                        this.uploadFile2(response.data.data.fileId)
                    }else{
                        this.$message.error(response.data.userTip)
                    }
                }).catch(function (error) {
                    console.log(error)
                })
            },
            uploadFile2(id) {
                this.axios.post('/api/module/data/update', {
                    moduleId: this.moduleId,
                    dataId: this.dataId,
                    fieldId: this.currentFieldId,
                    value: id,
                })
                .then(response=> {
                    if(response.data.code == 0){
                        this.$message.success('修改成功')
                        this.queryDetailsData()
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error);
                });
            },
            handleChange(id) {
                this.currentFieldId = id
            },
            viewCommodity() {
                this.comodityModal = true
                this.selectArr = []
                this.discountInfo = ''
                this.axios(
                    {
                        method:'get',
                        url:'/api/order/queryDimensionList', 
                        params: {
                            orderId: this.dataId,
                        }
                    }
                )
                .then(response=> {
                    if(response.data.code == 0){
                        this.commodityId = response.data.data.commodityId
                        this.dimensionList = response.data.data.dimensionList
                        let arr = response.data.data.dimensionList
                        for(let i = 0; i < arr.length; i++){
                            let obj = {}
                            obj.selected = ''
                            this.selectArr.push(obj)
                        }
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            cancelComodity() {
                this.comodityModal = false
            },
            sureComodity() {
                this.comodityModal = false
                let arr = []
                for(let i = 0; i < this.selectArr.length; i++){
                    arr.push(this.selectArr[i]['selected'])
                }
                this.axios.post('/api/order/updateSpecifications', {
                    orderId: this.dataId,
                    specificationsIdList: arr,
                })
                .then(response=> {
                    if(response.data.code == 0){
                        this.$message.success('订单提交成功')
                        this.queryDetailsData()
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error);
                });
            },
            chooseSpecifications1(i,id) {
                if(this.selectArr[i]['selected'] == id){
                    this.selectArr[i]['selected'] = ''
                }else{
                    this.selectArr[i]['selected'] = id
                }
                this.queryDiscountInfoData()
            },
            queryDiscountInfoData() {
                let arr = []
                for(let i = 0; i < this.selectArr.length; i++){
                    if(this.selectArr[i]['selected']!=''){
                        arr.push(this.selectArr[i]['selected'])
                    } 
                }
                if(arr.length == 0){
                    this.discountInfo = ''
                }else{
                    this.axios.post('/api/commodity/calculatePrice', {
                        commodityId: this.commodityId,
                        quantity: 1,
                        specificationsIdList: arr
                    })
                    .then(response=> {
                        if(response.data.code == 0){
                            this.discountInfo = response.data.data
                        }else{
                            this.$message.error(response.data.userTip);
                        }
                    })
                    .catch(error=> {
                        console.log(error);
                    });
                }
            },
            addTabDetail(id) {
                this.id = id
                this.addNewDataModal = true
            },
            sureAddNewData() {
                this.addNewDataModal = false
                this.axios.post('/api/module/data/add', {
                    moduleId: this.id,
                    currentModuleId: this.moduleId,
                    currentDataId: this.dataId,
                    name: this.inputName
                })
                .then(response=> {
                    if(response.data.code == 0){
                        this.$message.success('新增成功')
                        this.inputName = ''
                        this.queryTabDetailData(this.associatedModuleId)
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error);
                });
            },
            cancelAddNewData() {
                this.addNewDataModal = false
                this.inputName = ''
            },
            getAuthority() {
                this.axios(
                    {
                        method:'get',
                        url:'/api/module/hasAddAuthority', 
                        params: {
                            moduleId: this.associatedModuleId
                        }
                    }
                )
                .then(response=> {
                    if(response.data.code == 0){
                        this.hasAddAuthority = response.data.data.hasAddAuthority
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            setCurrentTab() {
                this.currentTab = '数据详情'
            },
            cancelChooseAccount() {
                this.chooseAccountModal = false
                this.selectedRowKeys1 = []
            },
            sureChooseAccount() {
                let str = ''
                for(let i = 0; i < this.selectedRowKeys1.length; i++){
                    str+=this.selectedRowKeys1[i] + ','
                }
                str = str.substr(0, str.length - 1)
                this.chooseAccountModal = false
                this.axios.post('/api/module/data/update', {
                    moduleId: this.moduleId,
                    dataId: this.dataId,
                    fieldId: this.searchId,
                    value: str,
                })
                .then(response=> {
                    if(response.data.code == 0){
                        this.selectedRowKeys1 = []
                        this.queryDetailsData()
                        this.$message.success('关联成功')
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error);
                });
            },
            onSelectChange1(selectedRowKeys) {
                this.selectedRowKeys1 = selectedRowKeys;
            },
            connectAccount(id) {
                this.chooseAccountModal = true
                this.searchId = id
                this.queryAccountData()
            },
            queryAccountData() {
                this.axios(
                    {
                        method:'get',
                        url:'/api/commodity/commodityUserList', 
                        params: {
                            commodityId: this.dataId,
                            phone: this.searchNum
                        }
                    }
                )
                .then(response=> {
                    if(response.data.code == 0){
                        this.numberData1 = response.data.data.allUserList
                        for(let i = 0; i < this.numberData1.length; i++){
                            this.dataObj[this.numberData1[i]['id']] = this.numberData1[i]['phone']
                        }
                        let selectedData = response.data.data.commodityUserList
                        for(let i = 0; i < selectedData.length; i++){
                            this.selectedRowKeys1.push(selectedData[i]['userId'])
                        }
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            inputChange() {
                clearTimeout(this.timer)
                this.timer = setTimeout(()=>{
                    this.queryAccountData()
                },1500)
            },
            deleteSelectedNum(index) {
                this.selectedRowKeys1.splice(index, 1);
            },
            cleanSelected() {
                this.selectedRowKeys1 = []
            },
            queryUserList() {
                this.axios(
                    {
                        method:'get',
                        url:'/api/serviceProviderUser/userSelect', 
                    }
                )
                .then(response=> {
                    if(response.data.code == 0){
                        this.userList = response.data.data
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            chooseUser2(item) {
                this.userSonBool = false
                event.stopPropagation(); 
                let flag = true
                for(let i = 0; i < this.selectedUserList.length; i++){
                    if(this.selectedUserList[i]['id'] == item.id){
                        flag = false
                    }
                }
                if(flag){
                    this.selectedUserList.push(item)
                }
                for(let i = 0; i < this.boolList.length; i++){
                    this.boolList[i] = false
                }
                this.$forceUpdate()
            },
            removeSonUserList(index) {
                this.selectedUserList.splice(index,1)
                this.$forceUpdate()
            },
            cancelFatherComment() {
                this.selectedUserList = []
                document.getElementById("comment-textarea2").innerHTML = ''
            },
            showSonUserBox(index) {
                event.stopPropagation(); 
                this.userSonBool = true
                for(let i = 0; i < this.boolList.length; i++){
                    this.boolList[i] = false
                }
                this.boolList[index] = true
                this.$forceUpdate()
            },


            showUserListBox() {
                event.stopPropagation(); 
                this.userBool = true
                this.$forceUpdate()
            },
            chooseUser1(item) {
                this.userBool = false
                event.stopPropagation(); 
                let flag = true
                for(let i = 0; i < this.selectedUserList1.length; i++){
                    if(this.selectedUserList1[i]['id'] == item.id){
                        flag = false
                    }
                }
                if(flag){
                    this.selectedUserList1.push(item)
                }
                this.$forceUpdate()
            },
            removeUserList(index) {
                this.selectedUserList1.splice(index,1)
                this.$forceUpdate()
            },
            calcelSend() {
                this.selectedUserList1 = []
                document.getElementById("comment-textarea1").innerHTML = ''
                this.$forceUpdate()
            },
            toBottom() {
                const modalContent = document.querySelector('.affair-scroll');
                modalContent.scrollTo({ top: modalContent.scrollHeight, behavior: 'smooth' });
            },
            toTop() {
                const modalContent = document.querySelector('.affair-scroll');
                modalContent.scrollTo({ top: 0, behavior: 'smooth' });
            },
            handleDocumentClick(e) {
                if(e.target.className == 'comment-img'){
                    this.imgModal = true
                    this.imgUrl = e.target.src
                }
            },
            closeImgModal() {
                this.imgModal = false
            }
        },
        mounted: function() {
            document.addEventListener('click', this.handleDocumentClick);
        },
        beforeDestroy() {
            // 在组件销毁前移除事件监听，避免内存泄漏
            document.removeEventListener('click', this.handleDocumentClick);
        },
    }
</script>
<style scoped lang="less">
    .affair-modal{
        width:100%;
        height: 760px;
        .affair-head{
            height: 55px;
            border-bottom: 1px solid rgba(229, 229, 229, 1);
            padding: 16px 20px 0 24px;
            .affair-head-title{
                display: inline-block;
                width: 72px;
                height: 26px;
                line-height: 26px;
                text-align: center;
                background: rgba(24, 144, 255, 0.1);
                font-size: 13px;
                color: rgba(24, 144, 255, 1);
            }
            .affair-head-id{
                color: rgba(158, 172, 196, 1);
                font-size: 14px;
                margin-left: 12px;
            }
            .affair-head-btn-group{
                display: inline-block;
                float: right;
                .affair-head-btn1{
                    height: 26px;
                    font-size: 13px;
                    color: rgba(158, 172, 196, 1);
                    line-height: 24px;
                }
                .affair-head-btn2{
                    margin: 0 16px 0 11px;
                    height: 26px;
                    font-size: 13px;
                    color: rgba(158, 172, 196, 1);
                    line-height: 24px;
                }
                .affair-head-icon{
                    color: rgba(158, 172, 196, 1);
                    font-size: 16px;
                    cursor: pointer;
                    margin-left: 16px;
                }
            }   
        }
        .affair-body{
            height: 705px;
            width: 100%;
            .affair-content{
                height: 100%;
                width: 928px;
                display: inline-block;
                float: left;
                display: flex;
                flex-direction: column;
                border-right: 1px solid rgba(229, 229, 229, 1);
                position: relative;
                .to-bottom{
                    .to-bottom-text{
                        display: none;
                    }
                }
                .to-bottom:hover .to-bottom-text{
                    display: inline-block;
                }
                .to-bottom:hover .to-bottom-img{
                    display: none;
                }
                .to-top{
                    .to-top-text{
                        display: none;
                    }
                }
                .to-top:hover .to-top-text{
                    display: inline-block;
                }
                .to-top:hover .to-top-img{
                    display: none;
                }
                .affair-scroll{
                    flex: 1;
                    padding: 24px 24px 0 23px;
                    overflow-y: auto;
                    .affair-body-head{
                        height: 137px;
                        border-bottom: 1px solid rgba(229, 229, 229, 1);
                        .affair-body-head-title{
                            color: rgba(18, 18, 18, 1);
                            font-size: 16px;
                            font-weight: bold;
                        }
                        .affair-body-head-row{
                            margin-top: 20px;
                            .affair-body-head-name{
                                display: inline-block;
                                width: 36px;
                                height: 36px;
                                text-align: center;
                                line-height: 36px;
                                color: #fff;
                                font-size: 13px;
                                background: rgba(58, 220, 255, 1);
                                border-radius: 18px;
                                float: left;
                            }
                        }
                    }
                    .comment{
                        height: 30px;
                        border-bottom: 1px solid rgba(229, 229, 229, 1);
                        margin-top: 24px;
                        .comment-title{
                            display: inline-block;
                            height: 30px;
                            color: rgba(58, 220, 255, 1);
                            font-weight: bold;
                            font-size:13px;
                            border-bottom: 3px solid rgba(58, 220, 255, 1);
                        }
                    }
                    .comment-content{
                        padding: 21px 0;
                        .comment-list{
                            // display: flex;
                            margin-bottom: 24px;
                            background:rgba(158, 172, 196, 0.1);
                            border-radius: 8px;
                            // padding: 16px 16px 0 16px;
                            img{
                                width: 40px;
                                height: 40px;
                                margin-right: 16px;
                                border-radius: 8px;
                            }
                            .responce-content{
                                // border-bottom: 1px solid rgba(229, 229, 229, 1);
                                padding-bottom: 16px;
                                border-radius: 8px;
                                // flex: 1;
                                .name{
                                    color: rgba(158, 172, 196, 1);
                                    font-size: 12px;
                                    span{
                                        margin-right:10px;
                                    }
                                    margin-bottom: 0px;
                                }
                                .response-text{
                                    color: rgba(18, 18, 18, 1);
                                    font-size: 14px;
                                    // margin-bottom: 14px;
                                    font-weight:bold;
                                    word-break: break-all;
                                }
                                .comment-operate{
                                    span{
                                        cursor: pointer;
                                        color: rgba(121, 136, 155, 1);
                                        font-size: 12px;
                                    }
                                }
                                .response-to{
                                    margin-top: 8px;
                                    padding: 16px;
                                    background: rgba(247, 247, 247, 1);
                                    .name1{
                                        color: rgba(121, 136, 155, 1);
                                        font-size: 12px;
                                    }
                                    .name2{
                                        color: rgba(121, 136, 155, 1);
                                        font-size: 12px;
                                    }
                                    .res{
                                        color: rgba(80, 80, 80, 1);
                                    }
                                    .res-text{
                                        color: rgba(80, 80, 80, 1);
                                        font-size: 12px;
                                        word-break: break-all;
                                    }
                                    .time{
                                        color: rgba(153, 153, 153, 1);
                                        font-size: 12px;
                                        float: right;
                                    }
                                }
                            }
                            .username{
                                display: inline-block;
                                width: 40px;
                                height: 40px;
                                border-radius: 20px;
                                color: #fff;
                                text-align: center;
                                line-height: 40px;
                                background: rgba(121, 72, 234, 0.6);
                                font-size: 20px;
                                float: left;
                                margin-right: 16px;
                            }
                        }
                    }
                }
                .comment-box{
                    height: 267px;
                    border-top: 1px solid rgba(229, 229, 229, 1);
                    padding: 15px 24px 0;
                    display: flex;
                    position: relative;
                    .comment-box-name{
                        display: inline-block;
                        width: 36px;
                        height: 36px;
                        border-radius: 18px;
                        text-align: center;
                        line-height: 36px;
                        color: #fff;
                        font-size: 13px;
                        margin-right: 12px;
                        background: rgba(78, 138, 250, 1);
                    }
                    .comment-textarea{
                        height: 50px;
                        flex: 1;
                        border: rgba(158, 172, 196, 0.3) solid 1px;
                        resize: none;
                    }
                    .comment-btn-group{
                        position: absolute;
                        right: 36px;
                        bottom: 22px;
                        span:nth-child(1){
                            display: inline-block;
                            width: 48px;
                            height: 24px;
                            background: #fff;
                            color: rgba(158, 172, 196, 1);
                            text-align: center;
                            line-height: 24px;
                            cursor: pointer;
                            margin-right: 8px;
                            font-size: 12px;
                        }
                        span:nth-child(2){
                            display: inline-block;
                            width: 48px;
                            height: 24px;
                            background: rgba(58, 220, 255, 1);
                            color: #fff;
                            text-align: center;
                            line-height: 24px;
                            cursor: pointer;
                            font-size: 12px;
                        }
                    }
                }
            }
        }
        .tab-content{
            .ant-col{
                padding-right: 24px;
                height: 60px;
                margin-bottom: 20px;
            }
            .col-textarea{
                height: 110px;
            }
            .edit-input{
                border: 1px solid #fff;
                margin-top: 8px;
                color: rgba(18, 18, 18, 1);
            }
            .show-text{
                border: 1px solid #fff;
                margin-top: 8px;
                color: rgba(18, 18, 18, 1);
                button{
                    height: 23px;
                    line-height: 20px;
                    float: right;
                    font-size: 12px;
                    color: rgba(18, 18, 18, 1);
                }
                button:hover{
                    border: 1px solid #d9d9d9;
                }
            }
            .img-text{
                margin-top: 8px;
                img{
                    height: 32px;
                    cursor: pointer;
                }
            }
            .edit-input:hover{
                border: 1px solid rgba(158, 172, 196, 0.3);
            }
            .end-date{
                height: 34px;
                line-height: 34px;
                .date-picker{
                    display: none
                }
            }
            .end-date:hover{
                .date-text{
                    display: none;
                }
                .date-picker{
                    display: block;
                }
            }
            .related-business{
                margin-top: 8px;
                position: relative;
                .related-text{
                    font-size: 13px;
                    padding-top: 6px;
                    padding-left: 12px;
                    height: 24px;
                    position: absolute;
                    left: 0;
                    top: 0;
                    width: 100%;
                    height: 100%;
                    z-index: 100;
                    background: #fff;
                }
                .related-selected{
                    width: 100%;
                    border: none;
                    height: 100%;
                }
            }
            .related-business:hover{
                .related-text{
                    display: none;
                }
                .related-selected{
                    border: 1px solid rgba(158, 172, 196, 0.3);
                }
            }
        }
        .tab-detail{
            height: 60px;
            border-bottom: 1px solid rgba(229, 229, 229, 1);
            clear: both;
            .tab-title{
                color: rgba(18, 18, 18, 1);
                font-size: 13px;
                padding-top: 22px;
                display: inline-block;
                float: left;
                width: 480px;
                overflow: hidden;
                height: 42px;
            }
            .tab-label{
                margin-left: 12px;
                width: 225px;
                overflow: hidden;
                display: inline-block;
                margin-top: 18px;
                height: 28px;
                span{
                    float: left;
                }
            }
            .tab-owner{
                float: right;
                margin-top: 17px;
                display: inline-block;
                width: 28px;
                height: 28px;
                line-height: 28px;
                text-align: center;
                border-radius: 14px;
                background: rgba(35, 218, 119, 1);
                color: #fff;
                font-size: 12px;
            }
            .tab-img{
                float: right;
                width: 28px;
                margin-top: 17px;
                border-radius: 14px;
            }
            .tab-createtime{
                float: right;
                margin-right: 8px;
                margin-top: 20px;
                color: rgba(158, 172, 196, 1);
                font-size: 13px;
                display: inline-block;
                width: 118px;
            }
        }
        .tab-attachment{
            .attachment-head{
                padding: 20px 0;
                .total-data{
                    padding-top: 4px;
                    display: inline-block;
                    color: rgba(18, 18, 18, 1);
                    font-size: 13px;
                }
                .upload-file{
                    float: right;
                    button{
                        background: rgba(158, 172, 196, 0.12);
                        color: rgba(158, 172, 196, 1);
                        font-size: 13px;
                        border: none;
                        height: 28px;
                        line-height: 28px;
                    }
                }
            }
            .attachment-list{
                li{
                    height: 58px;
                    padding-top: 16px;
                    border-bottom: 1px solid rgba(229, 229, 229, 1);
                    .attachment-top{
                        .attachment-name{
                            color: rgba(18, 18, 18, 1);
                            font-size: 13px;
                            display: inline-block;
                            width:480px;
                            overflow: hidden;
                            line-height:30px;
                        }
                        .attachment-btn-group{
                            float: right;
                            // margin-top:10px;
                            i{
                                color: rgba(158, 172, 196, 1);
                                font-size: 14px;
                                cursor: pointer;
                                margin-left: 12px;
                            }
                        }
                    }
                    .attachment-bottom{
                        // margin-top: 4px;
                        width: 250px;
                        display:inline-block;
                        span{
                            color: rgba(158, 172, 196, 1);
                            font-size: 12px;
                        }
                        span:nth-child(2){
                            margin: 0 12px;
                        }
                    }
                }
            }
        }
        .affair-tab{
            height: 30px;
            margin-top: 25px;
            span{
                display: inline-block;
                margin-right: 32px;
                color: rgba(158, 172, 196, 1);
                font-size: 13px;
                height: 30px;
                cursor: pointer;
            }
            span.active{
                color: rgba(58, 220, 255, 1);
                border-bottom: 3px solid rgba(58, 220, 255, 1);
            }
        }
        .head-item{
            position: relative;
            .select-name{
                display: inline-block;
                width: 36px;
                height: 36px;
                text-align: center;
                line-height: 36px;
            }
            .selected-name{
                display: inline-block;
                width: 36px;
                height: 36px;
                text-align: center;
                line-height: 36px;
                color: #fff;
                font-size: 13px;
                background: rgba(78, 138, 250, 1);
                border-radius: 18px;
                float: left;
            }
            .person-charge{
                margin-left: 12px;
                color: rgba(158, 172, 196, 1);
                font-size: 13px;
                margin-top: 8px;
            }
            .personal-charge{
                flex: 1;
                margin-left: 12px;
                position: relative;
                .personal-charge-name{
                    color: rgba(18, 18, 18, 1);
                    font-size: 13px;
                }
                .personal-charge-user{
                    color: rgba(158, 172, 196, 1);
                    font-size: 12px;
                }
                .personal-charge-close{
                    color: #ddd;
                    position: absolute;
                    top: 12px;
                    right: 45px;
                    cursor: pointer;
                    display: none;
                }
                .personal-charge-close:hover{
                    color: #007bff;
                }
            }
            .personal-charge:hover{
                .personal-charge-close{
                    display: inline-block;
                }
            }
            .person-box{
                width: 280px;
                height: 456px;
                box-shadow: 0px 2px 16px 0px rgba(0, 0, 0, 0.12);
                position: absolute;
                bottom: -470px;
                left: -90px;
                background: #fff;
                z-index: 1000;
                padding: 16px 0;
                display: flex;
                flex-direction: column;
                .person-box-tab{
                    height: 38px;
                    border-bottom: 1px solid rgba(229, 229, 229, 1);
                    line-height: 26px;
                    padding-left: 14px;
                    span{
                        display: inline-block;
                        // height: 38px;
                        color: rgba(158, 172, 196, 1);
                        font-size: 13px;
                        margin-right: 40px;
                        cursor: pointer;
                        margin-top:10px;
                    }
                    span.active{
                        border-bottom: 3px solid rgba(58, 220, 255, 1);
                        color: rgba(58, 220, 255, 1);
                    }
                }
                .user-provider-box{
                    flex: 1;
                    padding: 8px 0;
                    overflow-y: auto;
                    .user-box{
                        ul{
                            li{
                                height: 44px;
                                padding: 10px 20px 0;
                                cursor: pointer;
                                span:nth-child(1){
                                    display: inline-block;
                                    width: 24px;
                                    height: 24px;
                                    color: #fff;
                                    line-height: 24px;
                                    text-align: center;
                                    font-size: 12px;
                                    margin-right: 8px;
                                    border-radius: 12px;
                                    background: rgba(58, 220, 255, 1);
                                }
                                span:nth-child(2){
                                    color: rgba(18, 18, 18, 1);
                                    font-size: 13px;
                                }
                                i{
                                    float: right;
                                    color: rgba(58, 220, 255, 1);
                                    font-size: 16px;
                                    margin-top: 6px;
                                    
                                }
                            }
                            li:hover{
                                background: rgba(240, 242, 243, 0.5);
                            }
                        }
                    }
                }
            }
        }
        .create-time{
            position: relative;
            .select-time{
                display: inline-block;
                width: 36px;
                height: 36px;
                text-align: center;
                line-height: 36px;
                z-index: 10001;
            }
            .select-time:hover{
                cursor: default;
            }
            .time-charge{
                flex: 1;
                margin-left: 12px;
                position: relative;
            }
        }
        .edit-time{
            position: relative;
            .select-time{
                display: inline-block;
                width: 36px;
                height: 36px;
                text-align: center;
                line-height: 36px;
                z-index: 10001;
            }
            .select-time:hover{
                cursor: default;
            }
            .time-charge{
                flex: 1;
                margin-left: 12px;
                position: relative;
                .time-charge-close{
                    color: #ddd;
                    position: absolute;
                    top: 12px;
                    right: 45px;
                    cursor: pointer;
                    display: none;
                    z-index: 100002;
                }
            }
            .time-charge:hover{
                .time-charge-close{
                    display: inline-block;
                }
            }
            .create-time-picker{
                position: absolute;
                left: 0px;
                top: 0px;
                z-index: 10000;
                opacity: 0;
                cursor: pointer;
            }
            .create-time-picker:hover{
                .time-charge-close{
                    display: inline-block;
                }
            }
        }
        .affair-tags{
            .selected-item{
                height: 28px;
                line-height: 28px;
                display: inline-block;
                padding: 0 12px;
                margin-right: 12px;
                // background: rgba(255, 195, 0, 1);
                color: #fff;
                font-size: 13px;
                cursor: pointer;
                margin-top: 7px;
                i{
                    font-size: 12px;
                    margin-left: 4px;
                    display: none;
                }
            }
            .selected-item:hover{
                padding: 0 5px;
                font-size: 12px;
                i{
                    display: inline-block;
                }
            }
            .plus-button{
                margin-top: 7px;
                color: rgba(158, 172, 196, 1);
                background: rgba(158, 172, 196, 0.12);
                height: 28px;
                font-size: 13px;
                border: none;
                cursor: pointer;
                height: 28px;
                display: inline-block;
                line-height: 28px;
                text-align: center;
                position: relative;
                width: 85px;
                .carry-btn{
                    width: 85px;
                    height: 28px;
                    display: inline-block;
                }
                .tags-box{
                    display: inline-block;
                    width: 240px;
                    height: 238px;
                    position: absolute;
                    left: 0px;
                    top: 32px;
                    box-shadow: 0px 2px 16px 0px rgba(0, 0, 0, 0.12);
                    z-index: 100;
                    cursor: default;
                    background: #fff;
                    padding: 10px 0;
                    display: flex;
                    flex-direction: column;
                    .tags-list{
                        flex: 1;
                        overflow-y: auto;
                        text-align: left;
                        .tags-list-li{
                            height: 38px;
                            line-height: 38px;
                            padding: 0 20px;
                            cursor: pointer;
                            span{
                                color: rgba(18, 18, 18, 1);
                                font-size: 13px;
                            }
                            i{
                                float: right;
                                margin-top: 13px;
                                color: rgba(58, 220, 255, 1);
                            }
                        }
                        .tags-list-li:hover{
                            background: rgba(240, 242, 243, 0.5);
                        }
                    }
                }
            } 
        }
        .helper{
            .personal{
                display: inline-block;
                width: 32px;
                height: 32px;
                line-height: 32px;
                text-align: center;
                color: #fff;
                font-size: 12px;
                border-radius: 16px;
                margin-right: 12px;
                background: rgba(58, 220, 255, 1);
                position: relative;
                span.personal-edit{
                    display: inline-block;
                    width: 12px;
                    height: 12px;
                    position: absolute;
                    top:-2px;
                    right: -1px;
                    background: #9EACC4;
                    color: #fff;
                    border-radius: 6px;
                    color: #fff;
                    line-height: 0px;
                    display: none;
                }
                .personal-img{
                    width: 32px;
                    border-radius: 16px;
                    position: absolute;
                    left: 0px;
                    top: 0px;
                }
            }
            .personal:hover{
                cursor: default;
                span.personal-edit{
                    display: inline-block;
                    cursor: pointer;
                }
            }
            .personal-add{
                display: inline-block;
                width: 32px;
                height: 32px;
                line-height: 32px;
                text-align: center;
                color: rgba(158, 172, 196, 1);
                font-size: 12px;
                border-radius: 16px;
                margin-right: 12px;
                border: 1px dashed rgba(158, 172, 196, 1);
                cursor: pointer;
            }
            .person-box{
                width: 280px;
                height: 400px;
                box-shadow: 0px 2px 16px 0px rgba(0, 0, 0, 0.12);
                position: absolute;
                bottom: -410px;
                left: 0px;
                background: #fff;
                z-index: 100;
                padding: 16px 0;
                display: flex;
                flex-direction: column;
                .person-box-tab{
                    height: 38px;
                    border-bottom: 1px solid rgba(229, 229, 229, 1);
                    line-height: 26px;
                    padding-left: 14px;
                    span{
                        display: inline-block;
                        // height: 38px;
                        color: rgba(158, 172, 196, 1);
                        font-size: 13px;
                        margin-right: 40px;
                        cursor: pointer;
                        margin-top:10px;
                    }
                    span.active{
                        border-bottom: 3px solid rgba(58, 220, 255, 1);
                        color: rgba(58, 220, 255, 1);
                    }
                }
                .user-provider-box{
                    flex: 1;
                    padding: 8px 0;
                    overflow-y: auto;
                    .user-box{
                        ul{
                            li{
                                height: 44px;
                                padding: 10px 20px 0;
                                cursor: pointer;
                                span:nth-child(1){
                                    display: inline-block;
                                    width: 24px;
                                    height: 24px;
                                    color: #fff;
                                    line-height: 24px;
                                    text-align: center;
                                    font-size: 12px;
                                    margin-right: 8px;
                                    border-radius: 12px;
                                    background: rgba(58, 220, 255, 1);
                                }
                                span:nth-child(2){
                                    color: rgba(18, 18, 18, 1);
                                    font-size: 13px;
                                }
                                i{
                                    float: right;
                                    color: rgba(58, 220, 255, 1);
                                    font-size: 16px;
                                    margin-top: 6px;
                                    
                                }
                            }
                            li:hover{
                                background: rgba(240, 242, 243, 0.5);
                            }
                        }
                    }
                }
            }
        }
        .textarea-content{
            color: rgba(18, 18, 18, 1);
            font-size: 13px;
            margin-top: 12px;
            border: 1px solid #fff;
            resize: none;
        }
        .textarea-content:hover{
            border: 1px solid rgba(158, 172, 196, 0.3);
        }
    }
    .add-new-data-modal{
        .add-title{
            padding: 20px 20px 14px 24px;
            span{
                color: rgba(18, 18, 18, 1);
                font-size: 14px;
                font-weight: bold;
            }
            i{
                float: right;
                color: rgba(158, 172, 196, 1);
                font-size: 16px;
                cursor: pointer;
            }
        }
        .add-data{
            border-top: 1px solid rgba(229, 229, 229, 1);
            padding: 16px 24px 24px 24px;
            i{
                color: rgba(255, 170, 0, 1);
                font-size: 20px;
                margin-right: 20px;
            }
            span{
                color: rgba(18, 18, 18, 1);
                font-size: 16px;
            }
        }
        .btn-group{
            padding: 0 20px 20px 0;
            height: 48px;
            div{
                float: right;
            }
            button{
                display: inline-block;
                width: 64px;
                height: 28px;
                margin-left: 8px;
                font-size: 13px;
            }
            button:nth-child(1){
                color: rgba(158, 172, 196, 1);
            }
        }
        .pic-content{
            text-align: center;
            img{
                width: 200px;
            }
        }
    }
    .comodity-modal{
        .add-title{
            padding: 20px 20px 14px 24px;
            span{
                color: rgba(18, 18, 18, 1);
                font-size: 14px;
                font-weight: bold;
            }
            i{
                float: right;
                color: rgba(158, 172, 196, 1);
                font-size: 16px;
                cursor: pointer;
            }
        }
        .comodity-data{
            padding: 0 24px;
            .good-item{
                display: flex;
                margin-top: 20px;
                .item-name{
                    color: rgba(169, 169, 169, 1);
                    font-size: 12px;
                    display: inline-block;
                    width: 144px;
                }
                .item-content{
                    flex: 1;
                }
                .item-choose1{
                    .item-select{
                        display: inline-block;
                        width: 200px;
                        height: 40px;
                        padding: 10px 0 0 16px;
                        color: rgba(18, 18, 18, 1);
                        font-size: 14px;
                        margin-right: 16px;
                        background: rgba(240, 242, 243, 1);
                        cursor: pointer;
                    }
                    .item-select2{
                        cursor: pointer;
                        span:nth-child(2){
                            display: inline-block;
                            width: 40px;
                            height: 18px;
                            line-height: 18px;
                            text-align: center;
                            font-size: 10px;
                            background: rgba(255, 141, 26, 1);
                            color: #fff;
                            margin-left: 12px;
                        }
                    }
                    div.active{
                        border: 1px solid rgba(58, 220, 255, 1);
                        background: rgba(58, 220, 255, 0.08);
                    }
                }
                .item-choose2{
                    .item-select{
                        display: inline-block;
                        width: 200px;
                        height: 40px;
                        padding: 10px 0 0 16px;
                        color: rgba(18, 18, 18, 1);
                        font-size: 14px;
                        margin-right: 16px;
                        background: rgba(240, 242, 243, 1);
                        cursor: pointer;
                    }
                    .item-select2{
                        cursor: pointer;
                        span:nth-child(2){
                            display: inline-block;
                            width: 40px;
                            height: 18px;
                            line-height: 18px;
                            text-align: center;
                            font-size: 10px;
                            background: rgba(255, 141, 26, 1);
                            color: #fff;
                            margin-left: 12px;
                        }
                    }
                    div.active{
                        border: 1px solid rgba(58, 220, 255, 1);
                        background: rgba(58, 220, 255, 0.08);
                    }
                }
            }
        }
        .btn-group{
            padding: 0 20px 20px 0;
            height: 48px;
            div{
                float: right;
            }
            button{
                display: inline-block;
                width: 64px;
                height: 28px;
                margin-left: 8px;
                font-size: 13px;
            }
            button:nth-child(1){
                color: rgba(158, 172, 196, 1);
            }
        }
        .pic-content{
            text-align: center;
            img{
                width: 200px;
            }
        }
    }   
    .choose-account-modal{
        .add-title{
            padding: 20px 20px 14px 24px;
            border-bottom: 1px solid rgba(229, 229, 229, 1);
            span{
                color: rgba(18, 18, 18, 1);
                font-size: 14px;
                font-weight: bold;
            }
            i{
                float: right;
                color: rgba(158, 172, 196, 1);
                font-size: 16px;
                cursor: pointer;
            }
        }
        .choose-account-data{
            padding: 24px;
            .account-left-content{
                padding-right: 24px;
                border-right: 1px solid rgba(229, 229, 229, 1);
                .account-table{
                    margin-top: 24px;
                }
            }
            .account-right-content{
                padding-left: 24px;
                .choosed-title{
                    span:nth-child(1){
                        color: rgba(153, 153, 153, 1);
                        font-size: 14px;
                    }
                    span:nth-child(2){
                        color: rgba(58, 220, 255, 1);
                        font-size: 14px;
                        float: right;
                        cursor: pointer;
                    }
                }
                .choosed-content{
                    margin-top: 24px;
                    .choosed-item{
                        display: inline-block;
                        width: 132px;
                        height: 32px;
                        margin: 0 8px 8px 0;
                        background: rgba(121, 136, 155, 0.1);
                        text-align: center;
                        line-height: 32px;
                        padding: 0 8px;
                        .choosed-phone{
                            color: rgba(121, 136, 155, 1);
                            font-size: 16px;
                            float: left;
                            margin-top: 7px;
                        }
                        .choosed-number{
                            color: rgba(80, 80, 80, 1);
                            font-size: 14px;
                            display: inline-block;
                            width: 84px;
                            overflow: hidden;
                        }
                        .choosed-close{
                            color: rgba(153, 153, 153, 1);
                            font-size: 14px;
                            float: right;
                            margin-top: 8px;
                            cursor: pointer;
                        }
                    }
                }
            }
            .account-total{
                color: rgba(80, 80, 80, 1);
                font-size: 14px;
                margin-top: 24px;
            }
        }
        .btn-group{
            border-top: 1px solid rgba(229, 229, 229, 1);
            padding: 16px 20px 20px 0;
            height: 58px;
            div{
                float: right;
            }
            button{
                display: inline-block;
                width: 64px;
                height: 28px;
                margin-left: 8px;
                font-size: 13px;
            }
            button:nth-child(1){
                color: rgba(158, 172, 196, 1);
            }
        }
    }
    .modal-public{
        .divider1{
            margin: 0px 0 24px 0;
        }
        .divider2{
            margin: 24px 0 12px;
        }
        .divider3{
            margin: 0px 0 12px;
        }
        .btn-group{
            float: right;
            button{
                width: 64px;
                height: 32px;
                font-size: 14px;
            }
            button:nth-child(1){
                margin-right: 16px;
            }
        }
        .btn-group2{
            float: right;
            button{
                width: 64px;
                height: 32px;
                font-size: 14px;
            }
            button:nth-child(1){
                background: #fff;
                color: rgba(121, 136, 155, 0.7);
                border: 1px solid rgba(121, 136, 155, 0.5);
                margin-right: 16px;
            }
            button:nth-child(1):hover{
                background: rgba(121, 136, 155, 0.08);
            }
        }
    }

    .symbol-icon{
        font-size: 14px;
        cursor: pointer;
        color: #1890ff
    }
    .cancel-submit{
        float: right;
        span{
            font-size: 14px;
            margin-left: 16px;
            cursor: pointer;
        }
        span:nth-child(1){
            color: rgba(158, 172, 196, 1);
        }
        span:nth-child(2){
            color: rgba(24, 144, 255, 1);
        }
    }
    .selected-user{
        display: inline-block;
        div{
            display: inline-block;
            height: 24px;
            padding: 0 8px;
            line-height: 24px;
            color: rgba(80, 80, 80, 1);
            font-size: 12px;
            background: rgba(121, 136, 155, 0.1);
            margin-left: 4px;
            i{
                color: rgba(153, 153, 153, 1);
                cursor: pointer;
                margin-left: 8px;
            }
        }
    }
    .user-list1{
        display: inline-block;
        border: 1px solid #ccc;
        width:100px;
        max-height: 200px;
        overflow-x: hidden;
        overflow-y: auto;
        border-radius: 4px;
        position: absolute;
        left: 85px;
        top: 55px;
        z-index: 100;
        background: #fff;
        ul{
            li{
                line-height: 25px;
                cursor: pointer;
                padding-left: 8px;
            }
            li:hover{
                background: #eee;
            }
        }
    }
    .user-list2{
        display: inline-block;
        border: 1px solid #ccc;
        width:100px;
        max-height: 200px;
        overflow-x: hidden;
        overflow-y: auto;
        border-radius: 4px;
        position: absolute;
        left: 13px;
        top: 50px;
        z-index: 100;
        background: #fff;
        ul{
            li{
                line-height: 25px;
                cursor: pointer;
                padding-left: 8px;
            }
            li:hover{
                background: #eee;
            }
        }
    }
    .textarea-comment1{
        background: rgba(247, 247, 247, 1);
        border: none;
        resize: none;
        min-height: 120px;
        padding: 5px;
        position: relative;
        word-break: break-all;
    }
    .textarea-comment2{
        background: rgba(247, 247, 247, 1);
        border: none;
        resize: none;
        height: 70px;
        padding: 5px;
        position: relative;
        overflow-y: auto;
        word-break: break-all;
    }
    .release{
        margin-top: 4px;
    }
    .abcd{
        width:100px !important;
    }
</style>